{
    "controlHost":"wss://decentralized.app"
}